import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useProcess from "./useProcess";

export interface ResumableProcess {
  _id: string;
  pendingInnerProcess?: string | null;
}

/** Resume a running process exactly the way ContinueStrip does. */
export function useResumeRunning(): (p: ResumableProcess) => Promise<void> {
  const { resumeProcess } = useProcess();
  const location = useLocation();
  const { t } = useTranslation();
  return useCallback(
    async (p: ResumableProcess) => {
      await resumeProcess({
        processId: p.pendingInnerProcess || p._id,
        from: location,
        forward: location,
        onError: () => {
          toast.error(
            t("error_continuing_process") || "An error occurred while continuing the process. Please try again."
          );
        },
      });
    },
    [resumeProcess, location, t]
  );
}
